<script>
  import { flip } from 'svelte/animate';
  import { fly } from 'svelte/transition';
  import { notifications } from './notifications.js';

  export let themes = {
    danger: '#E26D69',
    success: '#4fb261',
    warning: '#f0ad4e',
    info: '#5bc0de',
    default: '#aaaaaa',
  };
</script>

<div class="notifications">
  {#each $notifications as notification (notification.id)}
    <div animate:flip class="toast" style="background: {themes[notification.type]};" transition:fly={{ y: 30 }}>
      <div class="content">{@html notification.message}</div>
      <button on:click={() => notifications.unsend(notification.id)}>X</button>
    </div>
  {/each}
</div>

<style>
  .notifications {
    position: fixed;
    bottom: 20px;
    left: 0;
    right: 0;
    margin: 0 auto;
    padding: 0;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
  }

  .toast {
    display: flex;
    align-items: center;
    flex: 0 0 auto;
    margin-bottom: 10px;
    box-shadow: rgba(100, 100, 111, 0.3) 0px 7px 29px 0px;
  }

  .content {
    padding: 10px;
    display: block;
    color: white;
    font-weight: 500;
  }
  button {
    margin: 4px;
    width: 4ch;
    border: none;
    border-left: 1px solid #fff;
    outline: none;
    background: none;
    color: #fff;
    cursor: pointer;
  }
  :global(.content *) {
    color: white;
  }
</style>
